import { asGqlData } from 'Src/types/widget-helpers';
import { useState, useEffect } from 'react';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { CORE_GET_FACEBOOK_CONNECT_CONFIG } from 'Utils/request/requestDictionary';
const query = `
  query {
    facebookConnect {
      isAvailable
    }
    wechatConnect {
      isAvailable
    }
  }
`;
export const useExtendedConnect = () => {
  const [isFacebookConnectAvailable, setIsFacebookConnectAvailable] = useState(false);
  const [isWechatConnectAvailable, setIsWechatConnectAvailable] = useState(false);
  const { data, isLoading } = useGQL({
    query,
    queryOptions: {
      requestName: CORE_GET_FACEBOOK_CONNECT_CONFIG,
    },
    cache: true,
  });
  useEffect(() => {
    const connectConfig = asGqlData<{
      facebookConnect?: { isAvailable?: boolean };
      wechatConnect?: { isAvailable?: boolean };
    }>(data);
    setIsFacebookConnectAvailable(!!connectConfig?.facebookConnect?.isAvailable);
    setIsWechatConnectAvailable(!!connectConfig?.wechatConnect?.isAvailable);
  }, [isLoading]);
  return {
    isFacebookConnectAvailable,
    isWechatConnectAvailable,
  };
};
